import { render } from "./AdminRelationFormFields.vue?vue&type=template&id=3fdc1d7b"
import script from "./AdminRelationFormFields.vue?vue&type=script&lang=js"
export * from "./AdminRelationFormFields.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__